import { SKU_LIST_BZ10 } from "./models/BZ10";
import { SKU_LIST_G5000 } from "./models/G5000";
import { SKU_LIST_G64000 } from "./models/G64000";
import { SKU_LIST_G64000K } from "./models/G64000K";
import { SKU_LIST_G64000L } from "./models/G64000L";
import { SKU_LIST_JH001 } from "./models/JH001";
import { SKU_LIST_JH030 } from "./models/JH030";
import { SKU_LIST_STTU758 } from "./models/STTU758";

export const AWDColorNames = {
    "AiBl": "Airforce Blue",
    "ArWh": "Arctic White",
    "As": "Ash",
    "BaPi": "Baby Pink",
    "BlSm": "Black Smoke",
    "BoGr": "Bottle Green",
    "Bu": "Burgundy",
    "BuOr": "Burnt Orange",
    "CaPi": "Candyfloss Pink",
    "Ch": "Charcoal",
    "CoBl": "Cornflower Blue",
    "Cr": "Cranberry",
    "DeSa": "Desert Sand",
    "DuPi": "Dusty Pink",
    "FiRe": "Fire Red",
    "FoGr": "Forest Green",
    "Go": "Gold",
    "HaBl": "Hawaiian Blue",
    "HeGy": "Heather Grey",
    "HoCh": "Hot Chocolate",
    "HoPi": "Hot Pink",
    "IcBl": "Ice Blue",
    "Ja": "Jade",
    "JeBl": "Jet Black",
    "KeGr": "Kelly Green",
    "Kh": "Khaki",
    "La": "Lavender",
    "LiGr": "Lime Green",
    "MoBr": "Mocha Brown",
    "MoGy": "Moondust Grey",
    "Mu": "Mustard",
    "NeFrNa": "New French Navy",
    "Nu": "Nude",
    "OlGr": "Olive Green",
    "OrCr": "Orange Crush",
    "OxNa": "Oxford Navy",
    "Pe": "Peppermint",
    "PiGr": "Pistachio Green",
    "Pl": "Plum",
    "Pu": "Purple",
    "RaGr": "Rainforest Green",
    "ReHoCh": "Red Hot Chilli",
    "RoBl": "Royal Blue",
    "SaBl": "Sapphire Blue",
    "SkBl": "Sky Blue",
    "SteGy": "Steel Grey",
    "StoGy": "Storm Grey",
    "SuYe": "Sun Yellow",
    "VaMi": "Vanilla Milkshake",
    "TuSu": "Turquoise Surf",
    "DeeBl": "Deep Black",
    "DeGr": "Dusty Green",
    "ShGr": "Shark Grey",
    "CaLa": "Caramel Latte",
    "DuRo": "Dusty Rose",
    "GiBi": "Ginger Biscuit",
    "EaGr": "Earthy Green",
    "PuPi": "Pumpkin Pie",
    "DiLa": "Digital Lavender",
    "ChFuBr": "Chocolate Fudge Brownie",
    "DuLi": "Dusty Lilac",
    "FeFu": "Festival Fuchsia",
    "GrHe": "Graphite Heather",
    "NaSt": "Natural Stone",
    "LaBl": "Lagoon Blue",
    "BrRo": "Bright Royal",
    "Se": "Seafoam",
    "ApGr": "Apple Green",
    "AtBl": "Atlantic Blue",
    "BrRe": "Brick Red",
    "BuSm": "Burgundy Smoke",
    "CaGr": "Cactus Green",
    "DeSeBl": "Deep Sea Blue",
    "DenBl": "Denim Blue",
    "LiOr": "Light Orange",
    "Lipstick Pink": "",
    "MaMa": "Magenta Magic",
    "MoGr": "Moss Green",
    "NaCl": "Natural Clay",
    "NaSm": "Navy Smoke",
    "PePe": "Peach Perfect",
    "PiCo": "Pina Colada",
    "PiPu": "Pinky Purple",
    "PlGr": "Platinum Grey",
    "ShLe": "Sherbet Lemon",
    "SpGr": "Spring Green",
    "SuOr": "Sunset Orange",
    "TrBl": "Tropical Blue",
    "TrVi": "True Violet",
    "UlVi": "Ultra Violet",
    "WiMu": "Wild Mulberry",
    "CaTo": "Caramel Toffee",
    "CoGr": "Combat Green",
    "DuBl": "Dusty Blue",
    "DuPu": "Dusty Purple",
    "InBl": "Ink Blue",
    "ReRu": "Red Rust",
    "Ci": "Citrus",
    "SoRe": "Soft Red",
    "LiPi": "Lipstick Pink",
}


export const GildanColorNames = {
    "Bl": "Black",
    "MilGr": "Military Green",
    "Or": "Orange",
    "DaHe": "Dark Heather",
    "San": "Sand",
    "LiBl": "Light Blue",
    "Ma": "Maroon",
    "IrGr": "Irish Green",
    "Pu": "Purple",
    "Cha": "Charcoal",
    "Wh": "White",
    "Na": "Navy",
    "DaCho": "Dark Chocolate",
    "Re": "Red",
    "Ro": "Royal",
    "AnSa": "Antique Sapphire",
    "Az": "Azalea",
    "CaRe": "Cardinal Red",
    "CaBl": "Carolina Blue",
    "FoGr": "Forest Green",
    "Nat": "Natural",
    "Da": "Daisy",
    "AnChRe": "Antique Cherry Red",
    "MiGr": "Mint Green",
    "InBl": "Indigo Blue",
    "GrHe": "Graphite Heather",
    "Li": "Lime",
    "Sap": "Sapphire",
    "Ki": "Kiwi",
    "Sky": "Sky",
    "Hel": "Heliconia",
    "StBl": "Stone Blue",
    "HeNa": "Heather Navy",
    "HeRo": "Heather Royal",
    "ChRe": "Cherry Red",
    "Pis": "Pistachio",
    "Par": "Paragon",
    "HeMiGr": "Heather Military Green",
    "JaDo": "Jade Dome",
    "TroBl": "Tropical Blue",
    "LiPi": "Light Pink",
    "CoBl": "Cobalt Blue",
    "BuGuPi": "Bubble Gum Pink",
    "Bu": "Burgundy",
    "CaGr": "Camouflage Green",
    "DuBl": "Dusty Blue",
    "DuRo": "Dusty Rose",
    "Fu": "Fuchsia",
    "HeBl": "Heather Blue",
    "HeGyMe": "Heather Grey Melange",
    "KeGr": "Kelly Green",
    "Mi": "Mint",
    "NaNa": "Nautical Navy",
    "OrNa": "Organic Natural",
    "PoPi": "Powder Pink",
    "SaGr": "Sage Green",
    "SoYe": "Soft Yellow",
    "SuBl": "Surf Blue",
    "To": "Toffee",
    "OffWh": "Off White",
    "SpGr": "Sport Grey",
};


export const BZColorNames = {
    "Bl": "Black",
    "MilGr": "Military Green",
    "Or": "Orange",
    "DaHe": "Dark Heather",
    "San": "Sand",
    "LiBl": "Light Blue",
    "Ma": "Maroon",
    "IrGr": "Irish Green",
    "Pu": "Purple",
    "Cha": "Charcoal",
    "Wh": "White",
    "Na": "Navy",
    "DaCho": "Dark Chocolate",
    "Re": "Red",
    "Ro": "Royal",
    "AnSa": "Antique Sapphire",
    "Az": "Azalea",
    "CaRe": "Cardinal Red",
    "CaBl": "Carolina Blue",
    "FoGr": "Forest Green",
    "Nat": "Natural",
    "Da": "Daisy",
    "AnChRe": "Antique Cherry Red",
    "MiGr": "Mint Green",
    "InBl": "Indigo Blue",
    "GrHe": "Graphite Heather",
    "Li": "Lime",
    "Sa": "Sapphire",
    "Ki": "Kiwi",
    "Sky": "Sky",
    "Hel": "Heliconia",
    "StBl": "Stone Blue",
    "HeNa": "Heather Navy",
    "HeRo": "Heather Royal",
    "ChRe": "Cherry Red",
    "Pis": "Pistachio",
    "Par": "Paragon",
    "HeMiGr": "Heather Military Green",
    "JaDo": "Jade Dome",
    "TroBl": "Tropical Blue",
    "LiPi": "Light Pink",
    "CoBl": "Cobalt Blue",
    "BuGuPi": "Bubble Gum Pink",
    "Bu": "Burgundy",
    "CaGr": "Camouflage Green",
    "DuBl": "Dusty Blue",
    "DuRo": "Dusty Rose",
    "Fu": "Fuchsia",
    "HeBl": "Heather Blue",
    "HeGyMe": "Heather Grey Melange",
    "KeGr": "Kelly Green",
    "Mi": "Mint",
    "NaNa": "Nautical Navy",
    "OrNa": "Organic Natural",
    "PoPi": "Powder Pink",
    "SaGr": "Sage Green",
    "SoYe": "Soft Yellow",
    "SuBl": "Surf Blue",
    "To": "Toffee"
};

export const STColorNames = {
    "Wh": "White",
    "Bl": "Black",
    "An": "Antracite",
    "FrNa": "French Navy",
    "HeGr": "Heather Grey"
}



let modelNames = {
    "G64000": "Gildan 64000",
    "G5000": "Gildan 5000",
    "G64000L": "Gildan 64000 Lady",
    "G64000K": "Gildan 64000 Kids",
    "BZ10": "Babybugz BZ10",
    "JH001": "AWDis JH001 College Hoodie",
    "JH030": "AWDis JH030 Sweatshirt",
    "STTU758": "Stanley/Stella Rocker"
}
/*
let tShirtProducts = {
    'G64000': {
        sizes: ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
        colors: [
            "Bl", "MilGr", "Or", "DaHe", "San", "LiBl", "Ma",
            "IrGr", "Pu", "Cha", "Wh", "Na", "DaCho", "Re", "Ro",
            "AnSa", "Az", "CaRe", "CaBl", "FoGr", "Nat", "Da",
            "AnChRe", "MiGr", "InBl", "GrHe", "Li", "Sa", "Ki",
            "Sky", "Hel", "StBl", "HeNa", "HeRo", "ChRe", "Pis",
            "Par", "HeMiGr", "JaDo", "TroBl"]
    },
    'G64000K': {
        sizes: ["XS", "S", "M", "L", "XL"],
        colors: [
            "Bl", "MilGr", "Or", "DaHe", "LiBl", "Ma",
            "IrGr", "Pu", "Cha", "Wh", "Na", "Re", "Ro",
            "LiPi", "Da", "GrHe", "Sa"]
    },
    'G64000L': {
        sizes: ["S", "M", "L", "XL", "2XL"],
        colors: [
            "Bl", "BuGuPi", "DaHe", "San", "LiBl", "Ma",
            "IrGr", "Pu", "Cha", "Wh", "Na", "Re", "Ro",
            "AnSa", "Az", "GrHe", "Sky", "Hel", "Pis", "Par"]
    }
}




let bodySuitProducts = {
    'BZ10': {
        sizes: ["03", "36", "612", "1218", "1824"],
        colors: [
            "Bl", "BuGuPi", "Bu", "CaGr", "CoBl", "DuBl",
            "DuRo", "Fu", "HeBl", "HeGyMe", "KeGr", "Mi", "NaNa",
            "OrNa", "PoPi", "Re", "SaGr", "SoYe", "SuBl", "To", "Wh"]
    }
}


// EXAMPLE: G64000-Wh-XL
let generateTShirtSKUs = () => {
    let result = [];

    for (let model in tShirtProducts) {
        for (let size of tShirtProducts[model].sizes)
            for (let color of tShirtProducts[model].colors)
                result.push(`${model}-${color}-${size}`);
    }
    return result;
}


// EXAMPLE: BZ10-03-Bl
let generateBodySuitSKUs = () => {
    let result = [];
    for (let model in bodySuitProducts) {
        for (let size of bodySuitProducts[model].sizes)
            for (let color of bodySuitProducts[model].colors)
                result.push(`${model}-${size}-${color}`);
    }
    return result;
}

*/

/*
export const availableTexPrintTShirtSKUs: string[] = [].concat(
    generateTShirtSKUs(),
    generateBodySuitSKUs()
);

*/
export const availableTexPrintClothesSKUs: string[] = [].concat(
    SKU_LIST_G64000,
    SKU_LIST_G64000K,
    SKU_LIST_G64000L,
    SKU_LIST_G5000,
    SKU_LIST_BZ10,
    SKU_LIST_JH001,
    SKU_LIST_JH030,
    SKU_LIST_STTU758
);[

];



export const texPrintProductNamesBySKU = {};


for (let sku of availableTexPrintClothesSKUs) {
    if (sku) {
        let skuSplit = sku.split('-');

        // Gildan 64000
        // Gildan 5000
        // JH
        // BZ
        // ST
        if (
            (skuSplit[0].startsWith('G64000')
            || skuSplit[0].startsWith('G5000')
                || skuSplit[0].startsWith('JH')
                || skuSplit[0].startsWith('BZ')
                || skuSplit[0].startsWith('ST'))
            && skuSplit.length == 3) {
            let model = modelNames[skuSplit[0]];
            let size = skuSplit[2];

            let color = skuSplit[1];

            if (skuSplit[0].startsWith('G64000'))
                color = GildanColorNames[skuSplit[1]];
            if (skuSplit[0].startsWith('G5000'))
                color = GildanColorNames[skuSplit[1]];
            if (skuSplit[0].startsWith('JH'))
                color = AWDColorNames[skuSplit[1]];
            if (skuSplit[0].startsWith('BZ'))
                color = BZColorNames[skuSplit[1]];
            if (skuSplit[0].startsWith('ST'))
                color = STColorNames[skuSplit[1]];


            if (model && color) {
                texPrintProductNamesBySKU[sku] = `${model} - ${color} - ${size}`;
            }
            else {
                texPrintProductNamesBySKU[sku] = sku;
            }
        }

    }
}
